document.addEventListener('DOMContentLoaded', function() {
  var badgeIds = ['prod-conrpt', 'prod-conrpt2', 'prod-conrpt3'];
  var stratamiBadges = document.getElementsByClassName('stratami'); 
  var lifestyleBadges = document.getElementsByClassName('lifestyle'); 
  var memoryBadges = document.getElementsByClassName('memory-foam-mattress'); 

  function applyBadgeStyles(element, isMobile) {
    if (!element) return;

    var badgeSize = element.getAttribute('data-badge-size');
    var badgeSizeMobile = element.getAttribute('data-badge-size-mobile');

    if (isMobile) {
      element.style.width = badgeSizeMobile + 'px';
      element.style.height = badgeSizeMobile + 'px';
    } else {
      element.style.width = badgeSize + 'px';
      element.style.height = badgeSize + 'px';
      element.style.zIndex = 9999;
  
      if (element.classList.contains('stratami')) {
        element.style.position = 'absolute';
        element.style.top = '10px';
        element.style.right = '10px'; 
      }
      if (element.classList.contains('lifestyle')) {
        element.style.position = 'absolute';
        element.style.top = '10px';
        element.style.right = '10px'; 
      }
      if (element.classList.contains('memory-foam-mattress')) {
        element.style.position = 'absolute';
        element.style.width = '180px';
        element.style.height = '63px';
        element.style.top = '10px';
        element.style.right = '10px'; 
      }
    }
  }

  function checkAndApplyStyles() {
    var isMobile = window.innerWidth <= 490;

 
    badgeIds.forEach(function(id) {
      var element = document.getElementById(id);
      applyBadgeStyles(element, isMobile);
    });

    Array.from(stratamiBadges).forEach(function(element) {
      applyBadgeStyles(element, isMobile);
    });

    Array.from(lifestyleBadges).forEach(function(element) {
      applyBadgeStyles(element, isMobile);
    });

    Array.from(memoryBadges).forEach(function(element) {
      applyBadgeStyles(element, isMobile);
    });
  }

  checkAndApplyStyles();

  window.addEventListener('resize', checkAndApplyStyles);
});
